import Route from "@ember/routing/route";

export default class DnsDomainDnsRecordsRoute extends Route {
  model() {
    return this.modelFor("dns.domain");
  }
}
